import {Component} from '@angular/core';

@Component({
	selector: 'login-page-layout',
	templateUrl: './login-page-layout.component.html'})
export class LoginPageLayoutWidget {}



// WEBPACK FOOTER //
// ./src/app/components/widgets/login-page-layout/login-page-layout.component.ts